import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Error';

export type IOKDialogBoxProps = {
    title?: string,
    content?: string,
}

const useStyles = makeStyles({
    root: {
        fontFamily: "Source Sans Pro",
    },
    closeButton: {
        position: 'absolute',
        right: 1,
        top: 1,
        color: "#707070",
    },
    content: { paddingBottom: 45, fontFamily: "Source Sans Pro", fontWeight: 500, },
    okbutton: {
        borderRadius: 2, backgroundColor: "#008381", textTransform: 'none',
        fontWeight: 500, fontFamily: "Source Sans Pro",
        boxShadow: "none",
        '&:hover': {
            backgroundColor: "#008381",
            textTransform: 'none',
            boxShadow: "none",
        },
        width: 90
    },
    title: { fontFamily: "Source Sans Pro", fontWeight: 600 },
    hr: { width: "100%", color: "#707070" },
    error: { color: "#c53535", paddingTop: 3 }
});

export default function MedicationErrorDialogBox(props: {
    dialogBoxProps: IOKDialogBoxProps,
    open: boolean,
    onactionedState: (val: boolean) => void
}) {
    const classes = useStyles();
    const handleClose = () => {
        props.onactionedState(false);
    };
    const handleConfirm = () => {
        props.onactionedState(false);
    };
    return (
        <div>
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className={classes.title} id="alert-dialog-title">
                    <ErrorIcon className={classes.error} /> {props.dialogBoxProps.title}</DialogTitle>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose} disableRipple>
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <DialogContentText className={classes.content} id="alert-dialog-description">
                        {props.dialogBoxProps.content}
                    </DialogContentText>

                </DialogContent>
                <hr className={classes.hr} />
                <DialogActions>
                    <Button variant="contained" size="medium" className={classes.okbutton} color="primary" onClick={handleConfirm} disableRipple>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
